import * as Sentry from '@sentry/react';
import Userback, { type UserbackWidget } from '@userback/widget';
import { USERBACK_ID } from '@/base/constants';

let userbackPromise: Promise<UserbackWidget | null> | null = null;

export const initiateUserback = () => {
  if (!userbackPromise) {
    userbackPromise = USERBACK_ID
      ? Userback(USERBACK_ID, {
          widget_settings: {
            position: 'se',
            language: 'en',
            logo: '/logo.svg',
            trigger_type: 'api',
          },
          // Mirrors the `chatwoot:opened` / `chatwoot:closed` events the other
          // widget emits, so both are observable the same way. A successful
          // send tears the form down through `reset()` instead of the close
          // button, so `after_send` is the only signal for that exit.
          on_open: () => window.dispatchEvent(new Event('userback:opened')),
          on_close: () => window.dispatchEvent(new Event('userback:closed')),
          after_send: () => window.dispatchEvent(new Event('userback:closed')),
        }).catch((err) => {
          Sentry.captureException(err, {
            extra: {
              message: 'Failed to load Userback widget',
            },
          });
          return null;
        })
      : Promise.resolve(null);
    (window as any).userbackPromise = userbackPromise;
    (window as any).userbackId = USERBACK_ID;
  }
  return userbackPromise;
};

export const openUserback = async () => {
  const userback = await initiateUserback();
  userback?.open();
};
